var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18645",
    "data-name": "Rectangle 18645",
    width: 22,
    height: 22,
    transform: "translate(886 4167)",
    fill: "#a5a5a5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_54",
    "data-name": "Mask Group 54",
    transform: "translate(-886 -4167)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98852",
    "data-name": "Group 98852",
    transform: "translate(886 4167.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98851",
    "data-name": "Group 98851",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98850",
    "data-name": "Group 98850",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215696",
    "data-name": "Path 215696",
    d: "M1.887,4.267A2.86,2.86,0,0,0-1,7.119,2.858,2.858,0,0,0-.144,9.151a2.719,2.719,0,0,0,2,.82h.071a2.7,2.7,0,0,0,1.925-.82A2.858,2.858,0,0,0,4.7,7.119a2.664,2.664,0,0,0-.82-2A2.7,2.7,0,0,0,1.887,4.267ZM3.349,8.652a1.963,1.963,0,0,1-1.5.606,2.164,2.164,0,0,1-1.5-.606A2.073,2.073,0,0,1-.287,7.119,2.13,2.13,0,0,1,1.887,4.98a2.08,2.08,0,0,1,1.462.606,2.131,2.131,0,0,1,.642,1.533A2.073,2.073,0,0,1,3.349,8.652Z",
    transform: "translate(1 -4.267)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215697",
    "data-name": "Path 215697",
    d: "M11.454,157.867H8.567a1.043,1.043,0,0,0-1.034,1.069v12.476A1.1,1.1,0,0,0,8.6,172.482h2.852a1.091,1.091,0,0,0,1.069-1.034V158.936A1.1,1.1,0,0,0,11.454,157.867Zm.356,13.581a.352.352,0,0,1-.356.321H8.6a.383.383,0,0,1-.356-.356V158.936a.352.352,0,0,1,.321-.356h2.887a.383.383,0,0,1,.356.356Z",
    transform: "translate(-7.177 -151.451)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215698",
    "data-name": "Path 215698",
    d: "M178.117,149.333h-.749A4.815,4.815,0,0,0,173.8,150.9v-.5a.767.767,0,0,0-.713-.713h-3.565a.732.732,0,0,0-.713.677v13.3a.7.7,0,0,0,.713.642h3.921a.7.7,0,0,0,.713-.642v-7.7a2.012,2.012,0,0,1,1.961-2.1,2.1,2.1,0,0,1,1.5.606,1.872,1.872,0,0,1,.5,1.462v7.664a.767.767,0,0,0,.713.713h3.565a.767.767,0,0,0,.713-.713v-9.2A4.954,4.954,0,0,0,178.117,149.333Zm4.278,14.223-.036.036h-3.493l-.036-7.664a2.625,2.625,0,0,0-.677-1.961,2.8,2.8,0,0,0-2-.82,2.748,2.748,0,0,0-2.673,2.816v7.628h-3.921V150.4h3.529l.036.036v2.246l.962-.962.036-.036a4.068,4.068,0,0,1,3.279-1.64h.749a4.254,4.254,0,0,1,4.242,4.349Z",
    transform: "translate(-161.719 -143.273)",
    fill: "#a5a5a5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial3);
export default __webpack_public_path__ + "static/media/social3.173b1530daf592420735498e2a4e16b7.svg";
export { ForwardRef as ReactComponent };